import { stringifyUrl } from "query-string";
import type { AddressMethodsItem, AddressMethodsParams } from "./type";
import { normalizeResponse } from "../../api/_helpers";

export async function fetchAddressMethods(options: AddressMethodsParams) {
  const url = `https://${
    process.env.REACT_APP_ENV === "test" ? "test-" : ""
  }eigentx-related-txs-method-tepu46la6a-uw.a.run.app`;

  const endpoint = stringifyUrl({ url, query: options });

  return await normalizeResponse<any, Array<AddressMethodsItem>>(
    fetch(endpoint),
    (data) => {
      return data;
    }
  );
}
